import React, { useState, useEffect } from "react";
import { IoClose } from "react-icons/io5";

const Resize = ({setResizeImage, currentImage, setCurrentImage, saveImageToHistory, setImageWithTransparentBackground }) => {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [aspectRatio, setAspectRatio] = useState(true);
  const [originalAspectRatio, setOriginalAspectRatio] = useState(0);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    // calculate the width and height of the image
    const img = new Image();
    img.src = currentImage;
    img.onload = () => {
      setWidth(img.width);
      setHeight(img.height);
      setOriginalAspectRatio(img.width / img.height);
    };
  }, [currentImage]);

  const handleWidthChange = (e) => {
    if(e.target.value === "") {
      setWidth(1);
      return;
    }
    const newWidth = parseInt(e.target.value, 10);
    setWidth(newWidth);
    if (aspectRatio) {
      setHeight(Math.round(newWidth / originalAspectRatio));
    }
  };

  const handleHeightChange = (e) => {
    if(e.target.value === "") {
      setHeight(1);
      return;
    }
    const newHeight = parseInt(e.target.value, 10);
    setHeight(newHeight);
    if (aspectRatio) {
      setWidth(Math.round(newHeight * originalAspectRatio));
    }
  };

  const handleResize = () => {
    console.log("currentImage", currentImage);
    if (!currentImage) return;

    setShowError(false);

    if(width === 0 || height === 0) {
      setShowError(true);
      console.log("showError", showError);
      return;
    }

    // Create a new canvas element
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    
    // Create a new image element to load the current image
    const img = new Image();
    
    // Set crossOrigin to handle CORS issues
    img.crossOrigin = "anonymous";
    
    img.onload = () => {
      // Set canvas dimensions to the desired size
      canvas.width = width;
      canvas.height = height;
      
      // Draw the image resized to the canvas
      ctx.drawImage(img, 0, 0, width, height);
      
      // Convert canvas to blob and then to URL
      canvas.toBlob((blob) => {
        const resizedImageUrl = URL.createObjectURL(blob);
        
        // Update the current image with the resized version
        setCurrentImage(resizedImageUrl);

        // new width and height
        console.log("new width", width);
        console.log("new height", height);

        saveImageToHistory(resizedImageUrl);
        setImageWithTransparentBackground(null);

        setResizeImage(false);
        
      }, "image/png");
    };
    
    // Handle error cases
    img.onerror = () => {
      console.error("Failed to load image for resizing");
    };
    
    // Load the current image
    img.src = currentImage;
  };

  return (
  <div className="relative">
    <div className="flex items-center justify-center h-full">
      {/* Control panel */}
      <div className="relative w-[250px] bg-gray-50 z-10 rounded-xl shadow flex flex-col">

        <div className="flex justify-between items-center p-3 border-b bg-white rounded-t-lg">
          <h3 className="text-base font-medium text-gray-700">Resize</h3>
          <button
            onClick={() => {
              setResizeImage(false);
            }}
            className="text-gray-500 hover:text-red-600 transition"
            title="Close"
          >
            <IoClose className="h-5 w-5" />

          </button>
        </div>

        <div className="flex flex-col p-3">

          {/* Width and Height in a compact grid */}
          <div className="grid grid-cols-2 gap-3 mb-2">
            <div className="space-y-1">
              <label className="block text-xs font-medium text-gray-600">Width(px)</label>
              <input
                type="number"
                value={width}
                onChange={handleWidthChange}
                className="w-full border border-gray-300 px-2 py-1.5 rounded text-sm focus:ring-1 focus:ring-blue-400 focus:border-blue-400"
                placeholder="px"
              />
            </div>
            <div className="space-y-1">
              <label className="block text-xs font-medium text-gray-600">Height(px)</label>
              <input
                type="number"
                value={height}
                onChange={handleHeightChange}
                className="w-full border border-gray-300 px-2 py-1.5 rounded text-sm focus:ring-1 focus:ring-blue-400 focus:border-blue-400"
                placeholder="px"
              />
            </div>
          </div>

          <div className="my-2 flex items-center gap-2">
            <input
              type="checkbox"
              checked={aspectRatio}
              onChange={() => setAspectRatio(!aspectRatio)}
              className="w-4 h-4 cursor-pointer"
            />
            <label className="text-sm cursor-pointer">Maintain Aspect Ratio</label>
          </div>

        </div>

        <div className="flex flex-col bg-white border-t rounded-b-lg p-2">

            <div className="flex justify-center w-full">
              <button
                onClick={handleResize}
                className="w-full border-2 px-6 py-2 text-sm rounded-lg bg-primary text-white hover:bg-primary-700 hover:text-white duration-300 transition cursor-pointer"
              >
                Resize
              </button>
            </div>

            {showError && (
              <div className="flex justify-center items-center mt-2">
                <p className="text-primary-500 text-xs text-center">Please enter a valid width and height</p>
              </div>
            )} 
        
        </div>
      </div>
    </div>
  </div>
  );
};

export default Resize;
